// Shared utility for handling API URL configuration
// This handles both development and production environments

const getApiBaseUrl = () => {
  // In development, check if we have the environment variable
  if (
    process.env.REACT_APP_API_URL &&
    process.env.REACT_APP_API_URL !== "REACT_APP_API_URL_PLACEHOLDER"
  ) {
    return process.env.REACT_APP_API_URL;
  }

  // Fallback to placeholder (will be replaced at runtime in production)
  return "REACT_APP_API_URL_PLACEHOLDER";
};

export const API_BASE_URL = getApiBaseUrl();
